import React, { useState } from "react";
import { toast } from "react-toastify";
import { useLoginMutation } from "../redux/features/auth/authApi";
import { useNavigate } from "react-router-dom";
import { ThreeCircles } from "react-loader-spinner";
import Logo from "../assets/logo.png";

function Login() {
  const navigate = useNavigate();
  const [formValues, setFormValues] = useState({
    email: "",
    password: "",
    loading: false,
  });
  const notify = (err) => toast.error(err);

  const handleForm = (e) => {
    const { value, name } = e.target;

    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  const [login, { isLoading }] = useLoginMutation();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await login({
        email: formValues.email,
        password: formValues.password,
      }).unwrap();
      navigate("/teams");
    } catch (err) {
      notify(err.data);
    }
  };
  return (
    <div className="grid place-items-center h-screen bg-[#F9FAFB">
      <div className="min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <div>
            <img
              className="mx-auto h-12 w-auto"
              src={Logo}
              alt="Learn with sumit"
            />
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
              Sign in to your account
            </h2>
          </div>
          <form className="mt-8 space-y-6">
            <div className="rounded-md shadow-sm -space-y-px">
              <div>
                <label for="email-address" className="sr-only">
                  Email address
                </label>
                <input
                  id="email-address"
                  name="email"
                  type="email"
                  value={formValues.email}
                  onChange={handleForm}
                  autocomplete="email"
                  required
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                  placeholder="Email address"
                />
              </div>
              <div>
                <label for="password" className="sr-only">
                  Password
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  value={formValues.password}
                  onChange={handleForm}
                  autocomplete="current-password"
                  required
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm"
                  placeholder="Password"
                />
              </div>
            </div>

            <div className="relative ">
              <button
                type="submit"
                onClick={handleLogin}
                disabled={isLoading}
                className={` ${
                  isLoading
                    ? "bg-black/25 "
                    : "bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
                }group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white `}
              >
                Sign in
              </button>
              <div className="absolute top-[50%] -translate-y-[50%] -translate-x-[50%] left-[50%] ">
                <ThreeCircles
                  height="30"
                  width="30"
                  color="#4C51BF"
                  wrapperStyle={{}}
                  wrapperclassName=""
                  visible={isLoading}
                  ariaLabel="three-circles-rotating"
                  outerCircleColor=""
                  innerCircleColor=""
                  middleCircleColor=""
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
